import { useState, forwardRef } from "react";
import PropTypes from "prop-types";
import { Switch } from "./Switch";
import { Sizes } from "./Sizes";
import { Description } from "./Description";
import { resolveMeasurements } from "./lib/resolve-measurements";
import styles from "./styles/content.module.css";
import { MeasurementsTable } from "./MeasurementsTable";

export const Content = forwardRef(
  ({ sizes, isBra = false, data, selectedSize, handleOptionChange, showFooter, product }, ref) => {
    const [isCM, setIsCM] = useState(true);

    if (!data) {
      return null;
    }

    const { fitDescription, body, garment } = data;

    let units = "cm";
    if (isBra) {
      units = "cm";
    } else if (!isCM) {
      units = "\u201D";
    }

    const {
      formattedData: bodyData,
      selectedMeasurements: selectedBodyMeasurements,
      title: bodyTitle,
    } = resolveMeasurements(body, selectedSize, product, units);

    let bodyImage = null;

    if (body) {
      bodyImage = body.img;
    }

    const {
      formattedData: garmentData,
      selectedMeasurements: selectedGarmentMeasurements,
      title: garmentTitle,
    } = resolveMeasurements(garment, selectedSize, product, units);

    let garmentImage = null;

    if (garment) {
      garmentImage = garment.garmentImage;
    }

    return (
      <article className={styles.container} ref={ref}>
        <article className={styles.header}>
          <Switch isBra={isBra} isCM={isCM} handleToggle={() => setIsCM(!isCM)} />
        </article>
        <div className={styles.fitDescription}>
          <Description description={fitDescription} />
        </div>
        {garmentData && (
          <MeasurementsTable
            title={garmentTitle}
            data={garmentData}
            units={units}
            image={garmentImage}
            description={garment.measurementDescription}
          />
        )}
        {bodyData && (
          <MeasurementsTable
            title={bodyTitle}
            data={bodyData}
            units={units}
            image={bodyImage}
            description={body.measurementDescription}
          />
        )}
      </article>
    );
  }
);

Content.propTypes = {
  sizes: PropTypes.array.isRequired,
  isBra: PropTypes.bool,
  selectedSize: PropTypes.string.isRequired,
  handleOptionChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};
